import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { IPayoutLimit } from '../payoutLimits/types';

import { fetchPaymentLimitsRequest } from './requestHandlers';

const defaultParams = {
  page: '0',
  size: '10',
};

export const loadPaymentLimitsStart = createAction('payment_limits/load/start');

export const loadPaymentLimitsListSuccess = createAction<IPayoutLimit[]>('payment_limits/load/success');

export const loadPaymentLimitsRequest = (
  history: RouteComponentProps['history'],
  params: IQueryParams = {},
  isInitialLoading?: boolean,
) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    if (isInitialLoading) {
      dispatch(loadPaymentLimitsStart());
    }
    const initialParams = qs.parse(history.location.search);
    const mergedParams = { ...defaultParams, ...initialParams, ...removeEmpty(params) };
    const data = await fetchPaymentLimitsRequest();
    if (data) {
      dispatch(loadPaymentLimitsListSuccess(data));
      history.replace({
        search: qs.stringify(mergedParams, { skipNull: true }),
      });
    }
  };
};
